@if (isMobile()) {
  <app-header
    [transparent]="false"
    [title]="i18n.langString('settings')"
  ></app-header>
}
<!-- @if(!isMobile()){
    <app-desktop-header></app-desktop-header>
} -->
<div
  class="content"
  [class.desktop]="!isMobile()"
  [class.em]="cfg.appName === 'em'"
>
  <div class="more-info-group">
    @if (cfg.appName === "ia") {
      <div class="more-info-subgroup black-bg">
        <button>
          <app-more-info
            [variant]="'more-info-flat-white'"
            [grouped]="true"
            [blackBg]="true"
            [fillWhite]="true"
            svgIcon="icons:installation_agent"
            svgIconRight="icons:arrow-right-up"
            (click)="toLoctitePulseapp(EquipmentMonitorURL())"
            >{{ i18n.langString("go_to_em") }}
          </app-more-info>
        </button>
      </div>
    }
    @if (cfg.appName === "em") {
      <div class="more-info-subgroup black-bg">
        <button>
          <app-more-info
            [variant]="'more-info-flat-white'"
            [grouped]="true"
            [blackBg]="true"
            [fillWhite]="true"
            svgIcon="icons:installation_agent"
            svgIconRight="icons:arrow-right-up"
            (click)="toLoctitePulseapp(InstallationAgentURL())"
            >{{ i18n.langString("go_to_ia") }}
          </app-more-info>
        </button>
      </div>
    }
    <div class="more-info-subgroup">
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:profile"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('profile')"
          >{{ i18n.langString("profile") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:forgot_password"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('change-password')"
          >{{ i18n.langString("change_password") }}
        </app-more-info>
      </button>
    </div>
    <div class="more-info-subgroup">
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:language"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('language')"
          >{{ i18n.langString("language") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:metric"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('metric')"
          >{{ i18n.langString("measurement_system") }}
        </app-more-info>
      </button>
      @if (cfg.appName === "em") {
        <button>
          <app-more-info
            [variant]="'more-info-flat'"
            [grouped]="true"
            svgIcon="icons:bell"
            svgIconRight="icons:arrow-right"
            (click)="toSubpage('notifications')"
            >{{ i18n.langString("notifications") }}
          </app-more-info>
        </button>
      }
    </div>
    <div class="more-info-subgroup">
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:technical_documents"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('technical_documents')"
          >{{ i18n.langString("technical_documents") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:help"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('help')"
          >{{ i18n.langString("help_and_support") }}
        </app-more-info>
      </button>
    </div>
    <div class="more-info-subgroup">
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:terms"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('imprint')"
          >{{ i18n.langString("imprint2") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:terms"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('terms-of-use')"
          >{{ i18n.langString("terms_of_use") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:terms"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('data-protection')"
          >{{ i18n.langString("data_protection_declaration") }}
        </app-more-info>
      </button>
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:terms"
          svgIconRight="icons:arrow-right"
          (click)="toSubpage('service-conditions')"
          >{{ i18n.langString("service_conditions") }}
        </app-more-info>
      </button>
      @if (i18n.languageSignal() !== "de") {
        <button>
          <app-more-info
            [variant]="'more-info-flat'"
            [grouped]="true"
            svgIcon="icons:terms"
            svgIconRight="icons:arrow-right"
            (click)="toSubpage('note-for-us-residents')"
            >{{ i18n.langString("note_for_us_residents") }}
          </app-more-info>
        </button>
      }
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:terms"
          svgIconRight="icons:arrow-right"
          (click)="cookieBannerService.cookieSettings()"
          >{{ i18n.langString("cookies_settings") }}
        </app-more-info>
      </button>
    </div>
    <div class="more-info-subgroup">
      <button>
        <app-more-info
          [variant]="'more-info-flat'"
          [grouped]="true"
          svgIcon="icons:logout"
          svgIconRight="icons:arrow-right-up"
          (click)="logout()"
          >{{ i18n.langString("logout") }}
        </app-more-info>
      </button>
    </div>
  </div>
</div>
